import React from "react";
import {urlEnGeneral} from "../../_services/cart/tiendaHost";

/**
 * En una tienda propia no existen el panel del vendedor, el back office ni el alta de vendedores:
 * son del sitio general. Quien llega a esas rutas desde una tienda se va a la misma ruta en
 * deautopartes.ar (y alla se loguea con su usuario de siempre).
 */
export class IrAlGeneral extends React.Component {
    componentDidMount() {
        const {pathname, search} = window.location;
        window.location.replace(urlEnGeneral(pathname + search));
    }

    render() {
        return null;
    }
}
